import React, { Component, Fragment, createRef } from 'react';
import { CloseOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { createPortal } from 'react-dom';
import Table from '@/components/EditableTable';
import Panel from '@/components/Panel';
import {
  ImpVRM,
  ImpVrmDisplay,
  sortReference
} from '@/services/Cascade/Impedance';
import designConstructor from '../../../services/helper/designConstructor';
import { getAllCascadeComponents, getAllCascadeNets } from '../../../services/Cascade/helper/setupData';
import { Spin } from 'antd';

const VRMColumns = [
  {
    title: 'Eq. Pwr Pin',
    dataIndex: 'powerPin',
    width: '30%',
  }, {
    title: 'Eq. Gnd Pin',
    dataIndex: 'groundPin',
    width: '30%',
  }, {
    title: 'Component',
    dataIndex: 'VRM_COMP',
    width: '40%'
  }
]

const ExtraVRMColumns = [
  {
    title: 'Eq. Pwr Pin',
    dataIndex: 'powerPin',
    width: '30%',
  }, {
    title: 'Eq. Gnd Pin',
    dataIndex: 'groundPin',
    width: '30%',
  }, {
    title: 'Component',
    dataIndex: 'VRM_COMP',
    width: '40%'
  }
]
class VRMCompPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      VRM: [],
      references: [],
      loading: true,
      extraVRM: []
    }
    this.inputRef = createRef();
    this.dialogRoot = document.getElementById('root');
  }

  componentDidUpdate(prevProps) {
    const { close, noPCB, vrmLoading, record } = this.props;
    if (close && close !== prevProps.close) {
      this.closeModal()
    }
    if (noPCB !== prevProps.noPCB) {
      this.initColumns()
    }
    if (vrmLoading) {
      this.props.searchVRMLoading(false);
      this.initVRM();
    }
  }

  initColumns = () => {

    VRMColumns[0].render = (text = []) => {
      return <div className="cascade-vrm-pin-content">
        <span>{text.map(item => item && item.comp ? `${item.comp} - ${item.pins.join(', ')}` : '').join('; ')}</span>
      </div>
    }

    ExtraVRMColumns[0].render = (text = []) => {
      const { nets = [] } = this.state;
      const _text = text.map(item => {
        if (item && item.comp) {
          const net = nets.find(n => n.pins.some(pin => pin.comp === item.comp && pin.pins.some(p => item.pins.includes(p))))
          return `${item.comp} - ${item.pins.join(', ')}${net ? ` (${net.name})` : ''}`
        }
        return ''
      })
      return <div className="cascade-vrm-pin-content">
        <span>{_text}</span>
      </div>
    }

    VRMColumns[0].onCell = (record) => {
      const { powerPinList = [], noPCB } = this.props;
      const { powerPin = [] } = record;
      return !noPCB ? {
        edit: 'aurora-select',
        record,
        dataIndex: 'powerPin',
        options: powerPinList.map(item => item.name),
        selectType: "powerPin",
        text: `${powerPin.map(item => item && item.comp ? `${item.comp} - ${item.pins.join(', ')}` : '').join('; ')}`,
        getPopupContainer: document.getElementById("root"),
        handleSave: (record) => this.saveVRMPin(record, 'powerPin')
      } : {
        edit: false
      }
    }


    VRMColumns[1].render = (text = []) => {
      return <div className="cascade-vrm-pin-content">
        <span>{text.map(item => item && item.comp ? `${item.comp} - ${item.pins.join(', ')}` : '')}</span>
      </div>
    }

    ExtraVRMColumns[1].render = (text = []) => {
      return <div className="cascade-vrm-pin-content">
        <span>{text.map(item => item && item.comp ? `${item.comp} - ${item.pins.join(', ')}` : '')}</span>
      </div>
    }

    VRMColumns[1].onCell = (record) => {
      const { noPCB, extraReferenceComps = [] } = this.props;
      const { groundPin = [] } = record;
      const { references } = this.state;
      return !noPCB ? {
        edit: 'aurora-select',
        record,
        dataIndex: 'groundPin',
        options: [...references, ...extraReferenceComps],
        selectType: "groundPin",
        text: `${groundPin.map(item => item && item.comp ? `${item.comp} - ${item.pins.join(', ')}` : '').join('; ')}`,
        getPopupContainer: document.getElementById("root"),
        handleSave: (record) => this.saveVRMPin(record, 'groundPin')
      } : {
        edit: false
      }
    }

    VRMColumns[2].render = (text, record) => {
      return (
        <div style={{ position: 'relative', minHeight: 20 }}>
          <span>{text ? text.join(', ') : ''}</span>
          <CloseOutlined
            className="impedance-vrm-delete-icon"
            onClick={(e) => this.deleteRow(e, record)} />
        </div>
      );
    }

    ExtraVRMColumns[2].render = (text, record) => {
      return (
        <div style={{ position: 'relative', minHeight: 20 }}>
          <span>{text ? text.join(', ') : ''}</span>
        </div>
      );
    }

    VRMColumns[2].onCell = (record) => {
      const { noPCB, vrm = [] } = this.props;
      const { VRM_COMP = [] } = record;
      const { VRM } = this.state;
      const VRMs = VRM.map(item => item.VRM_COMP).flat(2);
      return !noPCB && (!VRM_COMP || !VRM_COMP.length) ? {
        edit: 'aurora-select',
        record,
        dataIndex: 'VRM_COMP',
        options: [...VRM_COMP, ...vrm.filter(item => !VRMs.includes(item))],
        selectType: "VRM_COMP",
        text: VRM_COMP,
        getPopupContainer: document.getElementById("root"),
        handleSave: (record) => this.saveVRMComp(record)
      } : {
        edit: false
      }
    }
  }

  componentDidMount = () => {
    this.props.onVRMRef && this.props.onVRMRef(this);
    this.initColumns();
    this.initVRM();
  }

  initVRM = () => {
    const { record = {}, referencePinList = [], designId = "", ReferenceNets, } = this.props;
    const { VRM = [], extraVRM } = record;
    let newVRM = VRM.map((vrm, index) => ({ ...vrm, index })), newExtraVRM = extraVRM.map((vrm, index) => ({ ...vrm, index }))
    const isPrelayout = designConstructor.isPreLayout(designId);
    const references = isPrelayout ? referencePinList : sortReference(referencePinList, designId, record.pwr, record.pwrPins, ReferenceNets);
    const nets = getAllCascadeNets({ pcbId: designId, info: true });
    this.setState({
      VRM: newVRM,
      references,
      loading: false,
      extraVRM: newExtraVRM,
      nets: [...nets.values()].map(net => ({ name: net.name, pins: Array.from(net.pins, ([key, value]) => ({ comp: key, pins: value })) }))
    })
  }

  saveVRMComp = (row) => {
    const { record, designId } = this.props;
    this.props.searchVRM(designId, record, row)
    this.setState({
      loading: true
    });
  }

  closeModal = () => {
    this.props.save();
    const { VRM } = this.state;
    const { record } = this.props;
    this.props.saveVRMComp(
      record,
      VRM.map(vrm => {
        delete vrm.index;
        return vrm
      })
    );
    this.props.closeVRMPanel()
  }

  addRow = (e) => {
    e.stopPropagation();
    const { voltage } = this.props
    const { VRM } = this.state;
    let model = VRM.length ? VRM[0].model : { id: '', name: '' };
    let newVRM = new ImpVRM(VRM.length + 1, model, voltage);
    this.setState({
      VRM: [...VRM, newVRM]
    })
  }

  deleteRow = (e, domain) => {
    e.stopPropagation();
    const index = domain.index;
    const { VRM } = this.state;
    const vrm = VRM[index];
    if (vrm && vrm.VRM_COMP && vrm.VRM_COMP.length) {
      const { designId, record } = this.props;
      this.setState({
        loading: true
      });
      this.props.removeVRM(designId, record, domain)
    } else {
      this.setState({
        VRM: VRM.filter(item => item.index !== index)
      });
    }
  }

  saveVRMPin = (record, type) => {
    const value = record[type];
    const index = record.index;
    const { VRM } = this.state;
    const { ReferenceNets = [], PowerNets = [], detail } = this.props;
    const newVRM = JSON.parse(JSON.stringify(VRM));
    const findIndex = newVRM.findIndex(item => item.index === index);
    if (findIndex > -1) {
      const { designId } = this.props;
      const current = getAllCascadeComponents({ pcbId: designId }).get(value)
      if (type === 'powerPin') {
        if (current) {
          const connectPowerNets = detail.map(path => {
            const lastIndex = path.findLastIndex(item => item.name === value);
            if (lastIndex < 1) {
              return null;
            }
            const net = path[lastIndex - 1];
            if (!net) {
              return null;
            }
            return net.name;
          }).flat().filter(item => !!item);
          const currentPins = [...current.pins.values()].filter(pin => (connectPowerNets.length ? connectPowerNets : PowerNets).includes(pin.net) && !ReferenceNets.includes(pin.net)).map(p => p.pin);
          const pins = currentPins ? currentPins : [...current.pins.values()].filter(p => !ReferenceNets.includes(p.net)).map(p => p.pin).sort();
          newVRM[findIndex].powerPin = [{ comp: value, pins: pins }]
        }
      } else if (type === 'groundPin') {
        if (current) {
          const currentPins = [...current.pins.values()].filter(pin => ReferenceNets.includes(pin.net) && !PowerNets.includes(pin.net)).map(p => p.pin);
          const pins = currentPins.length ? currentPins : [...current.pins.values()].filter(p => !PowerNets.includes(p.net)).pins.map(p => p.pin).sort();
          newVRM[findIndex].groundPin = [{ comp: value, pins: pins }]
        }
      }
      if (!newVRM[findIndex].VRM_COMP) {
        newVRM[findIndex].VRM_COMP = []
      }
    }
    this.setState({
      VRM: newVRM
    })
  }

  renderDialog = () => {
    const { VRM, loading, extraVRM } = this.state;
    const content = (
      <Panel
        className='impedance-panel'
        id='impedance-vrm-panel'
        title={<div className='impedance-panel-title'>VR Port Setting
          <PlusCircleOutlined className='impedance-comp-add-icon' onClick={(e) => this.addRow(e)} />
        </div>}
        onCancel={this.closeModal}
        zIndex={2000}
        width={1000}
        minWidth={200}
        minHeight={200}
        position='panel-center'
        draggable
        overflow={"auto"}
      >
        <Spin spinning={loading} tip="Loading...">
          <Table
            columns={VRMColumns}
            dataSource={VRM}
            size="small"
            rowKey={(record) => record.index}
            className='impedance-vrm-table cascade-imp-table'
            tablePadding={true}
          />
        </Spin>
        {
          extraVRM.length ? <div span={24} className='cascade-setup-border cascade-impedance-extra-vrm-display'>
            <span className="font-bold cascade-setup-title-color">Net Extension</span>
            <div className="space-10">
              <Table
                columns={ExtraVRMColumns}
                dataSource={extraVRM}
                size="small"
                rowKey={(record) => record.index}
                className='impedance-vrm-table cascade-imp-table'
                tablePadding={true}
              />
            </div>
          </div> : null
        }
      </Panel>
    );
    return createPortal(content, this.dialogRoot);
  }

  render() {
    const { text } = this.props;
    return <Fragment>
      <div className="editable-cell-value-wrap" ref={this.inputRef}>
        {text}
      </div>
      {this.renderDialog()}
    </Fragment>
  }
}

export default VRMCompPanel;
